import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminProductCosmeticBrandResponse } from './admin-product-cosmetic-brand.response';
import { AdminProductContextOperationsResponse } from './admin-product-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminProductCharacteristicResponse } from './admin-product-characteristic.response';
import { AdminProductAttributeResponse } from './admin-product-attribute.response';
import { AdminProductWarehouseProductResponse } from './admin-product-warehouse-product.response';
import { AdminProductStatus } from '../../enums/admin-product-status';

@jsonObject
export class AdminProductDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly password?: Nillable<string>;

  @jsonMember(Number)
  public readonly price?: Nillable<number>;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly status!: AdminProductStatus;

  @jsonMember(Boolean)
  public readonly virtual!: boolean;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminProductCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminProductCosmeticBrandResponse>;

  @jsonMember(AdminProductWarehouseProductResponse)
  public readonly warehouseGood?: Nillable<AdminProductWarehouseProductResponse>;

  @jsonMember(AdminProductContextOperationsResponse)
  public readonly contextOperations!: AdminProductContextOperationsResponse;

  @jsonArrayMember(MultimediaResponse)
  public readonly files?: Nillable<MultimediaResponse[]>;

  @jsonArrayMember(AdminProductCharacteristicResponse)
  public readonly characteristics?: AdminProductCharacteristicResponse[];

  @jsonArrayMember(AdminProductAttributeResponse)
  public readonly attributes?: AdminProductAttributeResponse[];
}
